// extracted by mini-css-extract-plugin
export default {"Card":"cardWithBorder_Card__BG8rR","CardHeader":"cardWithBorder_CardHeader__Fh3rA","CardBody":"cardWithBorder_CardBody__K6Hcw","CardFooter":"cardWithBorder_CardFooter__VQnbd"};